<template>
  <section class="">
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>Cycle schedule</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-spacer/>
        <v-btn text @click="$refs.studyCyclesCalendar.prev()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="mx-3">{{ $moment(focus).format('MMMM YYYY') }}</v-toolbar-title>
        <v-btn text @click="$refs.studyCyclesCalendar.next()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <v-spacer/>
        <v-btn small color="primary" class="box-shadow" @click="openCreateItemDialog">Create new</v-btn>
      </template>
    </v-toolbar>

    <v-container fluid>
      <v-card>
        <v-calendar ref="studyCyclesCalendar"
                    type="month"
                    color="primary"
                    :now="today"
                    v-model="focus"
                    :events="events"
                    :event-color="getEventColor"
                    :interval-minutes="90"
                    :interval-count="16"
                    :interval-height="40"
                    @click:event="openSelectedItemDialog"
                    @click:date="openDateCreateItemDialog"
                    @change="loadData"
        ></v-calendar>
      </v-card>
    </v-container>

    <v-dialog v-model="create_item_dialog" @click:outside="closeCreateItemDialog" max-width="500px">
      <v-card>
        <v-toolbar dense dark color="primary">Create cycle
          <v-spacer/>
          <v-btn icon @click="closeCreateItemDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text v-if="create_item">
          <date-field label="Start receiving" v-model="create_item.start_receiving"></date-field>
          <date-field label="Submission deadline" v-model="create_item.submission_deadline"></date-field>
          <date-field label="Return marked" v-model="create_item.return_marked"></date-field>
          <v-select v-model="create_item.practice_areas"
                    :items="practice_areas"
                    item-text="name"
                    item-value="id"
                    multiple outlined chips deletable-chips/>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="closeCreateItemDialog">cancel</v-btn>
          <v-btn color="primary" @click="createItemRequest">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog" max-width="500px">
      <v-card>
        <v-toolbar dense dark color="primary">Update cycle
          <v-spacer/>
          <v-btn icon @click="closeSelectedItemDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>

        <v-card-text v-if="selected_item">
          <date-field label="Start receiving" v-model="selected_item.start_receiving"></date-field>
          <date-field label="Submission deadline" v-model="selected_item.submission_deadline"></date-field>
          <date-field label="Return marked" v-model="selected_item.return_marked"></date-field>
          <v-select v-model="selected_item.practice_areas"
                    :items="practice_areas"
                    item-text="name"
                    item-value="id"
                    multiple outlined chips deletable-chips/>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="closeSelectedItemDialog">cancel</v-btn>
          <v-btn color="error" @click="deleteSelectedItemRequest">delete</v-btn>
          <v-btn color="primary" @click="updateSelectedItemRequest">Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </section>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data: () => ({
    today: '',
    focus: '',
    load_options: null,
    study_cycles: [],
    create_item: null,
    create_item_dialog: false,
    selected_item: null,
    selected_item_dialog: false,
    api_errors: []
  }),
  computed: {
    ...mapGetters({practice_areas: 'getPracticeAreas'}),
    events: function () {
      let items = []
      if(this.study_cycles.length > 0) {
        let mapped_items = this.study_cycles.map(item => ({
          ...item,
          name: ''+item.practice_areas.map(pa => pa.short_name),
          start: item.start_receiving,
          end: item.return_marked,
        }))
        items.push(...mapped_items)
      }
      return items
    }
  },
  created() {
    this.today = this.$currentTime().format('YYYY-MM-DD')
    this.focus = this.$currentTime().format('YYYY-MM-DD')
  },
  methods: {
    async loadData({start, end}) {
      this.load_options = {start, end}
      this.study_cycles = await this.axios.get(`api/study-cycles`, {
        params:{date_from: start.date, date_to: end.date}
      })
          .then(({data}) => data.data)
    },
    getEventColor() {
      return 'primary'
    },
    setToday() {
      this.today = this.$currentTime().format('YYYY-MM-DD')
      this.focus = this.$currentTime().format('YYYY-MM-DD')
    },
    openCreateItemDialog() {
      this.create_item = {
        start_receiving: '',
        submission_deadline: '',
        return_marked: '',
        practice_areas: []
      }
      this.create_item_dialog = true
    },
    openDateCreateItemDialog({date}) {
      this.create_item = {
        start_receiving: date,
        submission_deadline: this.$moment(date).add(1, 'weeks').format('YYYY-MM-DD'),
        return_marked: this.$moment(date).add(2, 'weeks').format('YYYY-MM-DD'),
        practice_areas: []
      }
      this.create_item_dialog = true
    },
    closeCreateItemDialog() {
      this.create_item_dialog = false
      this.create_item = null
      this.api_errors = []
    },
    createItemRequest() {
      this.app_loading = true
      this.api_errors = []
      this.axios.post('api/study-cycles', this.create_item)
        .then(({data}) => {
          this.study_cycles.push(data.data)
          this.closeCreateItemDialog()
        })
        .catch(errors => {this.api_errors = errors.response.data.errors})
        .then(() => {this.app_loading = false})
    },
    openSelectedItemDialog({event}) {
      this.selected_item = event
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
      this.api_errors = []
    },
    updateSelectedItemRequest() {
      this.app_loading = true
      this.api_errors = []
      this.axios.put(`api/study-cycles/${this.selected_item.id}`, this.selected_item)
          // eslint-disable-next-line no-unused-vars
          .then(({data}) => {
            this.loadData(this.load_options)
            this.closeSelectedItemDialog()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    },
    deleteSelectedItemRequest() {
      this.app_loading = true
      this.api_errors = []
      this.axios.delete(`api/study-cycles/${this.selected_item.id}`)
          // eslint-disable-next-line no-unused-vars
          .then(({data}) => {
            this.loadData(this.load_options)
            this.closeSelectedItemDialog()
          })
          .catch(errors => {this.api_errors = errors.response.data.errors})
          .then(() => {this.app_loading = false})
    },
  }
}
</script>